export default [
  {
    name: "Parrity",
    slug: "parrity",
    color: "#ffffff",
    logo: require("./img/products/Parrity.png"),
    brief:
      "Tutorials, courses, and eBooks from the brightest business minds of our time."
  },
  {
    name: "ONE App",
    slug: "one-app",
    color: "#000000",
    logo: require("./img/products/ONE-App.png"),
    brief:
      "A job marketplace for people in the film industry to showcase their work."
  },
  {
    name: "Rodrix",
    slug: "rodrix",
    color: "#ffffff",
    logo: require("./img/products/Rodrix.png"),
    brief: "One stop shop for all your fastener needs!"
  },
  {
    name: "MaxTV",
    slug: "max-tv",
    color: "#ffffff",
    logo: require("./img/products/MaxTV2.png"),
    brief:
      "Showcase your products, infographics, recipes, and videos at the heart of your clinic."
  },
  {
    name: "Blue Nile",
    slug: "blue-nile",
    color: "#ffffff",
    logo: require("./img/products/BlueNile.png"),
    brief:
      "A kiosk management app for the world`s leading diamond jeweler online"
  },
  {
    name: "Omnivia App",
    slug: "omnivia-app",
    color: "#b03221",
    logo: require("./img/products/Omnivia.png"),
    brief: "Monitoring your health online and in real-time"
  },
  {
    name: "Halden",
    slug: "halden",
    color: "#ffffff",
    logo: require("./img/products/HaldenEstate.png"),
    brief: "Real Estate CRM for Halden.estate"
  }
];
